import useContactInfosApi from "../../profiles/data/use_contact_infos_api";
import { CONTACT_OWNER_TYPE } from "./media_profile_context_management";

// Media Profile's contact-info action hook — a thin binding of the shared generic hook to this
// engine's owner id/type (mirrors use_media_outlet_contact_infos_api.jsx).
const useMediaProfileContactInfosApi = ({ mediaProfileId, silentReload, setGeneralError, setIsUpdating, isUpdating }) =>
  useContactInfosApi({
    contactOwnerId: mediaProfileId,
    contactOwnerType: CONTACT_OWNER_TYPE,
    silentReload,
    setGeneralError,
    setIsUpdating,
    isUpdating,
  });

export default useMediaProfileContactInfosApi;
